export const version = "strings/5.6.0";
//# sourceMappingURL=_version.js.map